import { Grid } from '@mui/material';
import { DataGrid, GridColDef, GridToolbar } from '@mui/x-data-grid';
import { useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { getConfiguredJobboards } from 'wisestep-api';
import { WsColors, Item, WsTypography, WsTypoVariants } from 'wisestep-base';

import CumulativeMatricValuesChart from '../../components/CumulativeMatricValuesChart/CumulativeMatricValuesChart';
import { IAggregation } from '../../types';

interface IData {
  aggregatedData: IAggregation[];
  sum: number;
}

const JobBoardsConfiguredTable = ({ workspaceId }: { workspaceId: string }) => {
  const paginationSize = 10;
  const tableData: Record<string, unknown>[] = [];

  const [aggregatedData, setAggregatedData] = useState<IData>({ aggregatedData: [], sum: 0 });

  useEffect(() => {
    const fetchData = async () => {
      const response = await getConfiguredJobboards(workspaceId);
      const total = response.data.hits.total;
      response.data.aggregations.aggregation.buckets.push({
        doc_count: total ?? 0,
        key: 'Total',
      });
      setAggregatedData({
        aggregatedData: response.data.aggregations.aggregation.buckets,
        sum: total,
      });
    };
    fetchData();
  }, [workspaceId]);

  aggregatedData?.aggregatedData?.map((item) => {
    item?.aggregation?.buckets?.map((item1) => {
      tableData.push({
        id: uuidv4(),
        jobboard: item.key,
        username: item1.key,
        count: item1.doc_count,
      });
    });
  });

  const columns: GridColDef[] = [
    { field: 'id', headerName: '', hide: true },
    {
      field: 'jobboard',
      headerName: `JobBoardName`,
      flex: 2,
    },
    {
      field: 'username',
      headerName: `UserName`,
      flex: 2,
    },
    {
      field: 'count',
      headerName: `No.Of Accounts (${aggregatedData.sum})`,
      flex: 2,
    },
  ];

  return (
    <>
      <CumulativeMatricValuesChart
        data={aggregatedData.aggregatedData}
        title="Count of Job Boards configured"
      />
      <Grid item xs={12} bgcolor={WsColors.White}>
        <Item>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} bold={true}>
            Job Boards configured at this point in Time By Users
          </WsTypography>
        </Item>
        <Item>
          <DataGrid
            rows={tableData}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={paginationSize}
            rowsPerPageOptions={[paginationSize]}
            autoHeight={true}
          />
        </Item>
      </Grid>
    </>
  );
};

export default JobBoardsConfiguredTable;
